function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 9H3.56L2.56 1H0V0H3.44L4.44 8H13V9Z",
  fill: "#10CFAB"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 7H5.43L5.3 6H12.37L13.59 3H3V2H15.03L13 7Z",
  fill: "#10CFAB"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.6499 13C5.30379 13 4.96544 12.8974 4.67766 12.7051C4.38987 12.5128 4.16557 12.2395 4.03311 11.9197C3.90066 11.5999 3.866 11.2481 3.93353 10.9086C4.00105 10.5691 4.16772 10.2573 4.41247 10.0126C4.65721 9.76782 4.96903 9.60115 5.3085 9.53363C5.64796 9.4661 5.99983 9.50076 6.3196 9.63321C6.63937 9.76567 6.91268 9.98997 7.10498 10.2778C7.29727 10.5655 7.3999 10.9039 7.3999 11.25C7.3999 11.7141 7.21553 12.1592 6.88734 12.4874C6.55915 12.8156 6.11403 13 5.6499 13ZM5.6499 10.5C5.50157 10.5 5.35656 10.544 5.23323 10.6264C5.10989 10.7088 5.01376 10.8259 4.95699 10.963C4.90023 11.1 4.88538 11.2508 4.91431 11.3963C4.94325 11.5418 5.01468 11.6754 5.11957 11.7803C5.22446 11.8852 5.3581 11.9567 5.50359 11.9856C5.64907 12.0145 5.79987 11.9997 5.93692 11.9429C6.07396 11.8861 6.19109 11.79 6.27351 11.6667C6.35592 11.5433 6.3999 11.3983 6.3999 11.25C6.39731 11.0519 6.31746 10.8626 6.17737 10.7225C6.03727 10.5824 5.84801 10.5026 5.6499 10.5Z",
  fill: "#10CFAB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.26 13C10.9135 13.002 10.5741 12.901 10.285 12.7099C9.99594 12.5188 9.77009 12.2462 9.6361 11.9266C9.50211 11.607 9.46603 11.2549 9.53242 10.9147C9.59881 10.5746 9.76468 10.2619 10.009 10.0161C10.2534 9.77037 10.5652 9.6027 10.9049 9.53437C11.2446 9.46603 11.597 9.50009 11.9174 9.63225C12.2377 9.7644 12.5116 9.98869 12.7044 10.2767C12.8971 10.5647 13 10.9034 13 11.25C13 11.7124 12.817 12.156 12.491 12.4839C12.1649 12.8118 11.7224 12.9973 11.26 13ZM11.26 10.5C11.1117 10.5 10.9667 10.544 10.8433 10.6264C10.72 10.7088 10.6239 10.8259 10.5671 10.963C10.5103 11.1 10.4955 11.2508 10.5244 11.3963C10.5534 11.5418 10.6248 11.6754 10.7297 11.7803C10.8346 11.8852 10.9682 11.9566 11.1137 11.9856C11.2592 12.0145 11.41 11.9996 11.547 11.9429C11.6841 11.8861 11.8012 11.79 11.8836 11.6666C11.966 11.5433 12.01 11.3983 12.01 11.25C12.0074 11.0519 11.9276 10.8626 11.7875 10.7225C11.6474 10.5824 11.4581 10.5026 11.26 10.5Z",
  fill: "#10CFAB"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/basket.eab2bbe4.svg";
export { SvgComponent as ReactComponent };